// Plazos del hipotecario de Itaú (INF-1974). En UI se puede pedir hasta 30 años, pero
// pasados los 20 Itaú pone condiciones: el préstamo no puede superar el equivalente a
// USD 400.000 (su API lo rechaza con un `error` y sin cuota), y el destino tiene que ser
// vivienda, sólo para residentes uruguayos. En USD el tope sigue en 10 años.
export const MAX_YEARS = { UI: 30, USD: 10 };
export const UI_YEARS_WITHOUT_CONDITIONS = 20;
export const LONG_TERM_MAX_LOAN_USD = 400_000;
const USD_CURRENCY_NAME = "U$S";

export const isLongTerm = (type: string, years: number) =>
	type === "UI" && years > UI_YEARS_WITHOUT_CONDITIONS;

// Sólo se aplica a avisos en dólares: con un precio en pesos el importe no se puede
// comparar contra USD 400.000, y ahí la regla la aplica Itaú.
export const exceedsLongTermMaxLoan = (
	type: string,
	years: number,
	loan: number,
	propertyCurrency: string
) =>
	isLongTerm(type, years) &&
	propertyCurrency === USD_CURRENCY_NAME &&
	loan > LONG_TERM_MAX_LOAN_USD;
